import { connect } from 'react-redux';
import {
  getRetentionExecutedQuery,
  getRetentionExecuteTime,
  getRetentionExecutionResult,
  getRetentionOptions,
} from '../../../reducers/analyticsApp';
import RetentionResult from '../../../components/retention/RetentionResult';

const mapStateToProps = (state) => {
  const executedQuery = getRetentionExecutedQuery(state);

  return {
    result: getRetentionExecutionResult(state),
    timezone: executedQuery ? executedQuery.timezone : null,
    dimensionType: executedQuery ? executedQuery.sequence.type : null,
    sequence: executedQuery ? executedQuery.sequence.units : null,
    executeTime: getRetentionExecuteTime(state),
    options: getRetentionOptions(state),
    executedQuery,
  };
};

export default connect(mapStateToProps)(RetentionResult);
